type ReqPostMessageKeyT = 'PAGE_RENDERED_AFTER_LOGIN' | 'BRIDGE_LOGIN_FAILED'
type ResPostMessageKeyT = 'LOG_OUT'

type CustomRecord<T extends ReqPostMessageKeyT | ResPostMessageKeyT> = Record<
  T,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { type: T; [key: string]: any }
>

export const ReqPostMessageRecord: CustomRecord<ReqPostMessageKeyT> = {
  PAGE_RENDERED_AFTER_LOGIN: {
    type: 'PAGE_RENDERED_AFTER_LOGIN',
  },
  BRIDGE_LOGIN_FAILED: {
    type: 'BRIDGE_LOGIN_FAILED',
  },
}

export const ResPostMessageRecord: CustomRecord<ResPostMessageKeyT> = {
  LOG_OUT: {
    type: 'LOG_OUT',
  },
}
